define('meeting-modal/gotomeet/personalize-meeting',['require','api-access','api-access','dialog-helper/responsive','tealium-utils','mixpanel-helper','meeting-modal/meeting-modal','meeting-modal/tab-options/profile-tab','knockout','durandal/app','plugins/dialog','lodash','i18next'],function (require) {
    var gotomeetApi = require('api-access').gotomeet;
    var meetingsApi = require('api-access').meetings;
    var responsiveDialog = require('dialog-helper/responsive');
    var tealiumUtils = require('tealium-utils');
    var mixpanelHelper = require('mixpanel-helper');

    var MeetingModal = require('meeting-modal/meeting-modal');
    var ProfileTab = require('meeting-modal/tab-options/profile-tab');

    var ko = require('knockout');
    var app = require('durandal/app');
    var dialog = require('plugins/dialog');
    var _ = require('lodash');
    var i18n = require('i18next');

    var PersonalizeMeeting = function (meetingId) {
        var self = this;

        // Inherit meeting-modal properties
        MeetingModal.call(self, meetingId);

        self.isShowingPreview = ko.observable(false);
        self.isShowingPreview.subscribe(function () {
            if (self.isShowingPreview()) {
                tealiumUtils.sendTealiumEvent('meetings', 'edit_preview');
            }
        });

        self.profileTab = ko.observable();
        self.showUrlConfirmation = ko.observable(false);

        // Use to check deeply if any option module is invalid.
        // Re-initialize here. Inheriting directly from meeting-modal will cause an error.
        self.validation = ko.observable();

        /**
         * Each module has a buildOption() function which will return an object formatted in a way the API expects.
         * Combine all those options to form the final object to be consumed by the API.
         */
        var combineOptions = function () {
            var meetingOptions = {};
            var combinedOptions = {};

            meetingOptions.meetingId = meetingId;
            meetingOptions.subject = self.profileTab().userRoomName() || i18n.t('meeting.schedule.title.default.text');

            meetingOptions = _.merge(meetingOptions, self.audioTab().buildOptions());
            meetingOptions = _.merge(meetingOptions, self.coorganizerTab().buildOptions());
            meetingOptions = _.merge(meetingOptions, self.startupTab().buildOptions());

            combinedOptions.meetingInfo = meetingOptions;

            combinedOptions = _.merge(combinedOptions, self.profileTab().buildOptions());

            return combinedOptions;
        };

        // Handles the actually submission to the API.
        self.submit = function () {
            var combinedOptions = combineOptions();

            gotomeetApi.update(self.profileTab().meetMe().profileId, combinedOptions)
                .then(function () {
                    app.trigger('gotomeet:profile', combinedOptions);
                    app.trigger('gotomeet:newSubject', combinedOptions.meetingInfo);
                    app.trigger('gotomeet:updatedProfileId', combinedOptions.profileId);

                    mixpanelHelper.track('GoToMeet.me Personalize a Meeting', {
                        ID: meetingId
                    });
                });

            /**
             * TODO: Removal of the coorganizer keys requires a separate distinct API call.
             * Sending an empty coorganizer keys array will not work. This behavior is flawed.
             * When that gets fixed, remove this section.
             */
            if (self.coorganizerTab().isCoorganizerEnabled() &&
                    combinedOptions.meetingInfo.coorganizerKeys &&
                    combinedOptions.meetingInfo.coorganizerKeys.length === 0) {
                meetingsApi.removeAllCoorganizers(meetingId);
            }

            self.close();
        };

        // If the user has modified the URL, throw up a confirmation dialog first,
        // otherwise, save immediately
        self.save = function () {
            if (self.profileTab().isUrlModified()) {
                $('.nav-tabs a[href="#profile"]').tab('show');
                self.showUrlConfirmation(true);
            } else {
                self.submit();
            }
        };

        self.close = function () {
            dialog.close(self);
        };

        self.activate = function () {
            self.profileTab(new ProfileTab(meetingId, self.submit));

            self.showUrlConfirmation = self.profileTab().showUrlConfirmation;

            self.validation = ko.validatedObservable({
                profileTab: self.profileTab().validation,
                audioTab: self.audioTab().validation
            });
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);

            // Show the profile tab by default
            $('.nav-tabs a[href="#profile"]').tab('show');

            $('.personalize-modal-container a[data-toggle="tab"]').on('shown.bs.tab', function () {
                var contentType = 'meetings';

                if (this.href.indexOf('profile') > -1) {
                    tealiumUtils.sendTealiumEvent(contentType, 'edit_profile');
                }

                if (this.href.indexOf('audio') > -1) {
                    tealiumUtils.sendTealiumEvent(contentType, 'edit_audio');
                }

                if (this.href.indexOf('coorg') > -1) {
                    tealiumUtils.sendTealiumEvent(contentType, 'edit_co_organizer');
                }

                if (this.href.indexOf('password') > -1) {
                    tealiumUtils.sendTealiumEvent(contentType, 'edit_password');
                }
            });
        };
    };

    // When show() is called, fetch the GoToMeetMe meeting ID and pass it to the module.
    PersonalizeMeeting.show = function () {
        return gotomeetApi.getByUserKey()
            .then(function (meeting) {
                tealiumUtils.sendTealiumEvent('meetings', 'edit-profile');
                dialog.show(new PersonalizeMeeting(meeting.meetingId));
            });
    };

    return PersonalizeMeeting;
});

